var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1136 15.5603L5.1603 8.61366C5.05109 8.48612 4.99402 8.32207 5.0005 8.15429C5.00698 7.98651 5.07653 7.82735 5.19526 7.70862C5.31399 7.58989 5.47315 7.52033 5.64094 7.51385C5.80872 7.50737 5.97277 7.56444 6.1003 7.67366L12.1003 13.6737L18.027 7.66031C18.1545 7.55109 18.3186 7.49402 18.4863 7.5005C18.6541 7.50698 18.8133 7.57654 18.932 7.69527C19.0508 7.814 19.1203 7.97316 19.1268 8.14094C19.1333 8.30873 19.0762 8.47278 18.967 8.60031L12.1136 15.5603Z",
    fill: "#5FD0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1136 16.5603L5.1603 9.61366C5.05109 9.48612 4.99402 9.32207 5.0005 9.15429C5.00698 8.98651 5.07653 8.82735 5.19526 8.70862C5.31399 8.58989 5.47315 8.52033 5.64094 8.51385C5.80872 8.50737 5.97277 8.56444 6.1003 8.67366L12.1003 14.6737L18.027 8.66031C18.1545 8.55109 18.3186 8.49402 18.4863 8.5005C18.6541 8.50698 18.8133 8.57654 18.932 8.69527C19.0508 8.814 19.1203 8.97316 19.1268 9.14094C19.1333 9.30873 19.0762 9.47278 18.967 9.60031L12.1136 16.5603Z",
    fill: "#011E29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.47472e490e2f7d4599d0cf82739923a4.svg";
export { ForwardRef as ReactComponent };